
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/autorzy/[slug]",
      function () {
        return require("private-next-pages/autorzy/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/autorzy/[slug]"])
      });
    }
  